import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";
import { addSocialLink } from "store/actions/userAction";
import { capitalizeFirstLetter } from "context";
import homePage from "../../../../assets/img/custom/athleteHomePgae.jpg";

const SocialMediaCard = ({ user, uid }) => {
  const dispatch = useDispatch();
  const [socialMediaName, setSocialMediaName] = useState("");
  const [socialMediaURL, setSocialMediaURL] = useState("");
  const [addLoader, setAddLoader] = useState(false);
  const [deleteLoader, setDeleteLoader] = useState(null);
  const [showAddForm, setShowAddForm] = useState(false);

  const handleAddSocial = (e) => {
    e.preventDefault();
    if (!socialMediaName || !socialMediaURL) {
      toast.error("Please select a platform and enter the URL");
      return;
    }
    setAddLoader(true);
    let temp = { name: socialMediaName, url: socialMediaURL };
    let social_media;
    const capitalizedName = capitalizeFirstLetter(socialMediaName);

    let fbRegex = /^(https?:\/\/)?(www\.)?facebook\.com\/[a-zA-Z0-9(\.\?)?]/;
    let instagramRegex = /^(https?:\/\/)?(www\.)?instagram\.com\/.+/;
    let twitterRegex = /^(https?:\/\/)?(www\.)?twitter\.com\/.+/;

    if (socialMediaName === "facebook" && !fbRegex.test(socialMediaURL)) {
      toast.error(`Invalid ${capitalizedName} URL`);
      setAddLoader(false);
      return;
    } else if (socialMediaName === "instagram" && !instagramRegex.test(socialMediaURL)) {
      toast.error(`Invalid ${capitalizedName} URL`);
      setAddLoader(false);
      return;
    } else if (socialMediaName === "twitter" && !twitterRegex.test(socialMediaURL)) {
      toast.error(`Invalid ${capitalizedName} URL`);
      setAddLoader(false);
      return;
    }

    if (user?.social_media) {
      const exists = user.social_media.some((entry) => entry.name === temp.name);
      if (exists) {
        toast.error(`${capitalizedName} link already exists`);
        setAddLoader(false);
        return;
      }
      social_media = [...user.social_media, temp];
    } else {
      social_media = [temp];
    }

    dispatch(
      addSocialLink(social_media, uid, () => {
        setSocialMediaName("");
        setSocialMediaURL("");
        setAddLoader(false);
        setShowAddForm(false);
      })
    );
  };

  const handleDeleteSocial = (index) => {
    setDeleteLoader(index);
    let social_media = user?.social_media.filter((_, idx) => idx !== index);
    dispatch(
      addSocialLink(social_media, uid, () => {
        setDeleteLoader(null);
      })
    );
  };

  const getPlatformIcon = (name) => {
    const platform = name?.toLowerCase() || "";
    if (platform.includes("facebook")) return "fab fa-facebook";
    if (platform.includes("instagram")) return "fab fa-instagram";
    if (platform.includes("twitter")) return "fab fa-twitter";
    return "fas fa-link";
  };

  return (
    <div className="saas-card">
      <div className="card-header-saas">
        <h3>Social Media Links</h3>
        {!showAddForm ? (
          <button className="saas-btn primary sm" onClick={() => setShowAddForm(true)}>
            + Add New Link
          </button>
        ) : (
          <button className="saas-btn secondary sm" onClick={() => setShowAddForm(false)}>
            Cancel
          </button>
        )}
      </div>

      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        {showAddForm && (
          <form onSubmit={handleAddSocial} style={{ background: "#f8fafc", padding: "16px", borderRadius: "12px", border: "1px solid #e2e8f0", marginBottom: "16px" }}>
            <div className="saas-input-wrapper">
              <label>Platform</label>
              <select
                className="saas-input"
                value={socialMediaName}
                onChange={(e) => setSocialMediaName(e.target.value)}
                required
              >
                <option value="">Select Platform</option>
                <option value="facebook">Facebook</option>
                <option value="instagram">Instagram</option>
                <option value="twitter">Twitter</option>
              </select>
            </div>
            <div className="saas-input-wrapper">
              <label>URL</label>
              <input
                type="text"
                placeholder={`Enter ${socialMediaName || "Platform"} URL`}
                className="saas-input"
                value={socialMediaURL}
                onChange={(e) => setSocialMediaURL(e.target.value)}
                disabled={!socialMediaName}
                required
              />
            </div>
            <button type="submit" className="saas-btn primary w-100 mt-2">
              {addLoader ? <Spinner size="sm" /> : "Save Link"}
            </button>
          </form>
        )}

        <div className="social-links-list" style={{ marginBottom: "16px" }}>
          {user?.social_media && user.social_media.length > 0 ? (
            user.social_media.map((social, idx) => (
              <div key={idx} className="social-link-item">
                <div className="social-left">
                  <i className={getPlatformIcon(social.name)}></i>
                  <div>
                    <div className="social-name">{capitalizeFirstLetter(social.name)}</div>
                    <a href={social.url} target="_blank" rel="noopener noreferrer" className="social-url">
                      {social.url}
                    </a>
                  </div>
                </div>
                <button
                  className="saas-btn danger sm"
                  style={{ height: '26px', padding: '0 8px' }}
                  onClick={() => handleDeleteSocial(idx)}
                  disabled={deleteLoader === idx}
                >
                  {deleteLoader === idx ? <Spinner size="sm" /> : <i className="fas fa-trash"></i>}
                </button>
              </div>
            ))
          ) : (
            <div style={{ textAlign: "center", padding: "20px 0", color: "#64748b", fontSize: "0.875rem" }}>
              No social media links added yet.
            </div>
          )}
        </div>

        <div style={{ marginTop: "auto", textAlign: "center" }}>
          <img src={homePage} alt="Athlete Home page template preview" style={{ maxWidth: "100%", height: "auto", borderRadius: "8px", border: "1px solid #f1f5f9" }} />
        </div>
      </div>
    </div>
  );
};

export default SocialMediaCard;
